<template>
  <div class="operation-container">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" v-show="showSearch">
      <el-form-item label="名称" prop="operationName">
        <el-input
            v-model="queryParams.operationName"
            placeholder="请输入名称"
            clearable
            @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"   @click="handleQuery">搜索</el-button>
        <el-button   @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row class="mb8">
      <el-col :span="1.5">
        <el-button
            type="primary"
            v-hasPermi="['system::operationManage::parentAdd']"
            @click="handleAdd()"
        >
          新增
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
            type="primary"
            @click="toggleExpandAll"
        >展开/折叠
        </el-button>
      </el-col>
      <el-col :span="5">
      </el-col>

      <!-- <el-col :span="1.5">
        <el-button
            v-if="apiName !== '/test-api'"
            type="primary"
            plain
            
            @click="onSynchronization"
        >
          一键同步
        </el-button>
      </el-col> -->


    </el-row>
    <!--&lt;!&ndash;      :tree-props="{children:'children',hasChildren:'hasChildren'}"&ndash;&gt;-->
    <!-- 数据表格 -->
    <el-scrollbar :height="scrollbar_height">
      <el-table
          :data="allOperation"
          v-if="refreshTable"
          style="width:100%"
          border
          row-key="operationId"
          :default-expand-all="isExpandAll"

      >
        <el-table-column
            prop="operationName"
            label="权限名称"
            width="180"
        >
        </el-table-column>
        <el-table-column
            prop="operationCode"
            label="权限标识"
            width="200"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="operationDesc"
            label="权限描述"
            width="200"
            align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template #default="scope">
            <el-button
                v-hasPermi="['system::operationManage::childAdd']"
                text
                type="primary"
                @click="handleAdd(scope.row)"
                v-if="scope.row.operationType !== 'F'"
            >
              新增
            </el-button>
            <el-button
                v-hasPermi="['system::operationManage::update']"
                text
                type="primary"
                @click="handleUpdate(scope.row)"
            >
              修改
            </el-button>
            <el-button
                v-hasPermi="['system::operationManage::delete']"
                text
                type="primary"
                @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加或修改操作对话框 -->
      <el-dialog :title="title" v-model="dialogOpen" width="600px" append-to-body>
        <el-form ref="dialogFormRef" :model="dialogFormData" :rules="dialogFormRules" label-width="80px">
          <el-row>
            <el-col :span="24" v-if="dialogFormData.parentId !== 'root' && dialogParentName !== ''">
              <el-form-item label="上级菜单" prop="organParentId">
                {{ dialogParentName }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" prop="operationName">
                <el-input  v-model="dialogFormData.operationName" placeholder="请输入名称"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编码" prop="operationCode">
                <el-input  v-model="dialogFormData.operationCode	" placeholder="请输入编码"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="类型" prop="operationType">
                <el-radio-group v-model="dialogFormData.operationType">
<!--                  <el-radio-->
<!--                      v-for="typeItem in store.getters.dictOption['operationType']"-->
<!--                      :label="typeItem.libraryCode"-->
<!--                  >-->
<!--                    {{typeItem.libraryName}}-->
<!--                  </el-radio>-->
                  <el-radio label="M">菜单</el-radio>
                  <el-radio label="C">目录</el-radio>
                  <el-radio label="F">按钮</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="描述" prop="operationDesc">
                <el-input  v-model="dialogFormData.operationDesc" placeholder="请输入描述"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">{{ $t('msg.universal.cancel') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button>
        </span>
        </template>
      </el-dialog>
    </el-scrollbar>
  </div>
</template>

<script setup>
import {getCurrentInstance, ref,computed} from "vue";
import {watchSwitchLang} from "@/utils/i18n";
import {
  modifyOperation,
  removeOperation,
  saveOperation,
  syncOperationFromDev
} from "@/api/system/operation";
// import {useStore} from "vuex";
import useSystemStore from '@/store/modules/system'
import {warnMsg,confirmBox,succesMsg} from "@/utils/msgBox.ts"

const apiName = process.env.VUE_APP_BASE_API

const {proxy} = getCurrentInstance()
defineOptions({
    name: "operationManage",
  })
// 查询参数
const queryParams = ref({
  operationName: ''
})
// 所有操作
const allOperation = ref([])
// 是否显示搜索
const showSearch = ref(false)
// 刷新表格
const refreshTable = ref(true)
// 是否展开所有
const isExpandAll = ref(false)
// 查询
const store = useSystemStore()
const handleQuery = async (forceRefresh) => {
  allOperation.value = await store.getAllOperations(forceRefresh)
}

const scrollbar_height = computed(() => {
  if (showSearch.value){
    return 'calc(100vh - 235px)'
  } else {
    return 'calc(100vh - 185px)'
  }

})


handleQuery()
watchSwitchLang(handleQuery)
// 重置数据
const resetQuery = () => {

}

// 展开折叠
const toggleExpandAll = () => {
  refreshTable.value = false
  isExpandAll.value = !isExpandAll.value
  proxy.$nextTick(() => {
    refreshTable.value = true
  })
}

// 一键同步
const onSynchronization = () => {
  syncOperationFromDev().then(resData => {
    succesMsg('同步成功')
    handleQuery(true) // 获取列表强制刷新
  })
}

// 添加
const handleAdd = (row) => {
  dialogReset() // 重置表单数据
  title.value = '新增'
  if (row != undefined) {
    dialogFormData.value.parentId = row.operationId
    dialogFormData.value.operationType = 'C'
    dialogParentName.value = row.operationName
  }
  dialogOpen.value = true
}

// 修改
const handleUpdate = (row) => {
  dialogReset() // 重置表单数据
  dialogFormData.value = {...row}
  dialogOpen.value = true // 显示对话框
}

// 删除
const handleDelete = async (row) => {
  if (row.children && row.children.length > 0){
    warnMsg('包含子节点，无法进行删除，如必须删除，请先删除子节点')
  }else {
    confirmBox('是否确定要删除').then( async () => {
      await removeOperation(row).then(resData => {
        if (resData.status === 1){
          handleQuery(true)
          succesMsg('删除成功')
        }
      })
    }).catch(err => {
    })

  }

}

// 对话框参数
const title = ref('')
const dialogFormRef = ref(null)
// 对话框form 值
const dialogFormData = ref({})
// 是否显示对话框
const dialogOpen = ref(false)
const dialogParentName = ref('')
// 校验规则
const dialogFormRules = {
  operationName: [
    {
      required: true,
      message: '名称不能为空',
      trigger: 'blur'
    }
  ],
  operationCode: [
    {
      required: true,
      message: '编码不能为空',
      trigger: 'blur'
    }
  ]
}

// 重置对话框表单数据
const dialogReset = () => {
  dialogFormData.value = {}
  dialogFormData.value.operationId = undefined        // 机构主键
  dialogFormData.value.parentId = 'root'           // 父节点主键
  dialogFormData.value.operationCode = undefined      // 编码
  dialogFormData.value.operationDesc = undefined      // 描述
  dialogFormData.value.operationName = undefined      // 名称
  dialogFormData.value.operationType = 'M'      // 类型

  dialogParentName.value = ''
}

// 关闭
const closed = () => {
  // 重置数据
  dialogFormRef.value.resetFields()
  dialogOpen.value = false
}

// 提交
const onConfirm = async () => {
  dialogFormRef.value.validate(async valid => {
    // 不合规直接返回
    if (!valid) return

    let resStatus = false
    // 修改
    if(dialogFormData.value.operationId){
      await modifyOperation(dialogFormData.value).then(resData => {
        if (resData.status === 1){
          resStatus = true
        }
      })
    } else {
      await saveOperation(dialogFormData.value).then(resData => {
        if (resData.status === 1){
          resStatus = true
        }
      })
    }

    if (resStatus){
      closed()
      handleQuery(true) // 获取列表强制刷新
    }
  })
}
</script>

<style lang="scss" scoped>
.operation-container {
  padding: 10px;
  :deep(.el-col) {
    margin-left: 5px;
  }
  :deep(.el-form-item__content){
    display: block;
  }
}
</style>